@if (itemPath) {
  <a
    [href]="itemPath"
    class="items-list-item cursor-pointer"
    [attr.data-e2e]="e2e"
    [ngClass]="{'disabled': isDisabled(), 'highlight': isHighlight()}"
    [ecmDisabledAction]="!isDisabled() && isDisabledEclair()"
    aria-label="{{ ariaLabel() || computedAriaLabel() }}"
    (click)="materialItemListConfirm();false"
    ecmTarget
    >
    <span class="sr-only">{{ ariaLabel() || computedAriaLabel() }}</span>
    <ng-container *ngTemplateOutlet="itemListContent"></ng-container>
  </a>
} @else {
  <div class="items-list-item">
    <ng-container *ngTemplateOutlet="itemListContent"></ng-container>
  </div>
}
<ng-template #itemListContent>
  @if (itemIcon && itemIcon.startsWith('icon-')) {
    <span
      class="item-icon"
      [ngClass]="itemIcon"
      aria-hidden="true"
    ></span>
  }
  @if (itemIcon && !itemIcon.startsWith('icon-')) {
    <img [src]="itemIcon" [alt]="itemAlt()" class="item-img" aria-hidden="true" />
  }
  <div class="item-container" aria-hidden="true" [ngClass]="{'item-loading': isLoading(), 'no-border-bottom': hasNoBorder()}">
    <div class="item-text">
      <span [attr.data-e2e]="e2e.concat('-label')" aria-hidden="true">{{ itemLabel() }}</span>
      @for (item of displayedText(); track item; let index = $index) {
        <small
          [attr.data-e2e]="e2e.concat('-text-', index.toString())"
          class="item-desc"
          aria-hidden="true"
          >
          {{item}}
        </small>
      }
    </div>
    @if (itemStatus) {
      <span
        class="item-status"
        [attr.data-e2e]="e2e.concat('status')"
        [ngClass]="getCssClassFromStatus(itemStatus)"
        aria-hidden="true"
      ></span>
    }
    @if (isLoading()) {
      <div class="ob1-spinner-determined spinner">
        <div class="ob1-spinner-determined-loader1 spinner-loader1"></div>
        <div class="ob1-spinner-determined-loader2 spinner-loader2"></div>
      </div>
    }
  </div>
</ng-template>
